import React from 'react';
import { FormattedMessage } from 'react-intl';
import { StyledLink, Colors } from 'modules/utils';
import { Typography } from '@material-ui/core';
import { StyledFooter } from '../styles';

const FormFooter = () => (
	<StyledFooter>
		<Typography className="login-page-footer-text">
			<FormattedMessage id="heading.footerText" /> <br />
			<StyledLink
				className="login-page-footer-text"
				target="_blank"
				href="https://www.lavu.com/terms-of-service"
				color={Colors.LIGHT_GREY_3}
				textDecoration="underline"
			>
				<FormattedMessage id="heading.termsOfService" />
			</StyledLink>
		</Typography>
	</StyledFooter>
);

export default FormFooter;
